import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import {
  StrictEnumPicker,
  StrictEnumPickerSchema,
  StrictEnumPickerValidation,
} from './StrictEnumPicker';

export const StrictEnumPickerExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'StrictEnumPicker',
    component: StrictEnumPicker,
    schema: StrictEnumPickerSchema,
    validation: StrictEnumPickerValidation,
  }),
);
